export { IndividualDetail } from './detail'
export { IndividualList } from './list'



// WEBPACK FOOTER //
// ./src/internal-app/pages/individuals/index.js